import React from 'react';
import { Row, Col, FormGroup, Panel } from 'react-bootstrap';
import { RichTextEditor, TextBox, MultiEmailBox } from 'fw/forms';
import { DocumentUpload, EmailCategoryCombo } from 'areas/shared/controls'
import { SetupTab } from 'areas/shared/pages/setup';
import { OutlineLabel } from 'areas/shared/components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Label, Button } from 'fw/components';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import * as App from 'modules/app/App';
import * as API from 'modules/app/API';

class TemplateInfoTab extends SetupTab {
	initialForm() {
		return {
			active: true,
			rowVersion: null
		}
	}

	privileges() {
		return {
			edit: App.hasPrivilege("AdminEmailTemplateSetupEdit")
		}
	}

	urls() {
		return {
			get: API.Emailing.url('/emailTemplateSetup/getTemplateInfo'),
			save: API.Emailing.url('/emailTemplateSetup/saveTemplateInfo')
		}
	}

	getRequest(selectedId) {
		return {
			emailTemplateCode: selectedId
		}
	}

	saveRequest() {
		return {
			emailTemplateCode: this.props.selectedId,
			description: this.state.form.description,
			body: this.state.form.body,
			subject: this.state.form.subject,
			supportingDocuments: this.state.form.supportingDocuments,
			cc: this.state.form.cc,
			bcc: this.state.form.bcc,
			rowVersion: this.state.form.rowVersion,
			emailCategory: this.state.form.emailCategory
		}
	}

	ready = () => {
		this.focusControl && this.focusControl.focus();

		if (this.state.form.supportingDocuments !== undefined && this.state.form.supportingDocuments.length === 0)
			this.addSupportingDocument();
	}

	_renderValidFields = () => {
		if (!this.state.form.validFields || this.state.form.validFields === "")
			return null;

		var fields = this.state.form.validFields.split(",");

		return (
			fields.map((f) => {
				return (
					<div style={{ height: '30px' }}>
						<OutlineLabel color='red' text={'[' + f + ']'} />
					</div>
				)
			})
		);
	}

	handleRemoveSupportingDocument = (e, i) => {
		e.preventDefault();

		let form = this.state.form;
		form.supportingDocuments.splice(i, 1);

		this.updatePostData(form, true);
	}

	handleUploadSupportingDocumentChange = (file, index) => {
		let form = this.state.form;

		form.supportingDocuments[index].storageToken = file.storageToken;
		form.supportingDocuments[index].fileName = file.fileName;

		this.updatePostData(form, true);
	}

	addSupportingDocument = (e) => {
		if (e !== undefined)
			e.preventDefault();
			
		let form = this.state.form;
		form.supportingDocuments.push({
			emailTemplateAttachId: -Math.abs(Date.now() | 0)
		});

		this.updatePostData(form);
	}

	updatePostData = (form, dirty) => {
		this.setState({ form });

		if (dirty === true)
			this.dirt();
	}

	renderSupportingDocuments = () => {
		return this.state.form.supportingDocuments.map((item, index) => {
			return (
				<Row key={item.emailTemplateAttachId}>
					<Col md={8}>
						<DocumentUpload
							storageToken={item.storageToken}
							fileName={item.fileName}
							onChange={file => this.handleUploadSupportingDocumentChange(file, index)}
							folder="emails"
						/>
					</Col>
					{index > 0 &&
						<Col md={1} style={{ marginTop: 5, textAlign: "left", marginLeft: -15, paddingLeft: 0 }}>
							<Button type="button" bsStyle="link" onClick={(e) => this.handleRemoveSupportingDocument(e, index)} title="Remove Financial Document">
								<FontAwesomeIcon icon={faTrashAlt} size="lg" color="black" />
							</Button>
						</Col>
					}
				</Row>
			)
		});
	};

	renderForm() {
		return (
			<React.Fragment>
				<Row>
					<Col md={4}>
						<FormGroup>
							<Label>Template Code</Label>
							<TextBox name="emailTemplateCode" disabled />
						</FormGroup>
					</Col>
				</Row>
				<Row>
				<Col md={4}>
						<FormGroup>
							<Label required>Template Title</Label>
							<TextBox name="description" maxLength={128} required ref={(c) => { this.focusControl = c; }} />
						</FormGroup>
					</Col>
					<Col md={5}>
						<FormGroup>
							<Label required>Email Category</Label>
							<EmailCategoryCombo name="emailCategory" placeholder="Email Category" clearable/>
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col md={9}>
						<FormGroup>
							<Label required>Email Subject</Label>
							<TextBox name="subject" maxLength={128} required ref={(c) => { this.focusControl = c; }} />
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col md={9}>
						<FormGroup>
							<Label>CC</Label>
							<MultiEmailBox name="cc" />
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col md={9}>
						<FormGroup>
							<Label>BCC</Label>
							<MultiEmailBox name="bcc" />
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col md={9}>
						<FormGroup>
							<Label>Email Supporting Document</Label>
							{this.renderSupportingDocuments()}
							<Button type="button" bsStyle="link" onClick={(e) => this.addSupportingDocument(e)}>
								Add another Supporting Document
							</Button>
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col md={12}>
						<FormGroup>
							<Row>
								<Col md={9}>
									<RichTextEditor enabled={this.state.enabled} name="body" height='900px' config={{ height: '350px' }} />
								</Col>
								<Col md={3}>
									<Panel>
										<Panel.Heading>Merge fields</Panel.Heading>
										<Panel.Body>
											{this._renderValidFields()}
										</Panel.Body>
									</Panel>
								</Col>
							</Row>
						</FormGroup>
					</Col>
				</Row>
			</React.Fragment>
		)
	}
}

export default TemplateInfoTab; 



// WEBPACK FOOTER //
// ./src/areas/admin/emailingTemplateSetup/templateInfo/TemplateInfoTab.js